/* eslint-disable react/style-prop-object */
import React, { useState, useEffect } from "react";
import {
  ApprovalStatus,
  CommonToAll,
  EquipmentInput,
  InspectionResultRegistration,
  InspectionStatus,
} from "../containers";
import BackendLayout from "../layouts/BackendLayout";
import { updateSettings } from "../services/SettingServices";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "flowbite-react";
import tenkenTheme from "../configs/themes/tenkenTheme";
import PageAlert from "../components/alerts/PageAlert";
import {
  setAlertSuccess,
  resetAlert,
  setErrors,
  clearErrors,
  fetchAppSettings,
  setPageLoading,
  clearPageLoading,
  setUpdateMachineBatchAlertError,
  setButtonProcessing,
  clearButtonProcessing,
} from "../store/actions";
import { getSettingPageSettings } from "../api/setting/pageApi";
import { setPageSettings } from "../store/actions/pageActions";
import { getRouteBreadcrumb } from "../services/BreadcrumbServices";
import { SETTING } from "../constants/routes";
import { errorStatusHandle } from "../utils/error-utils";
import useDocumentTitle from "../hooks/useDocumentTitle";
import {ButtonDPad, PageTitle, RedirectAlert} from "../components";
import { smoothScrollToTop } from "../utils/common-utils";
import _ from "lodash";
import {SETTING_PAGE} from "../constants/pageName";
import useRedirectPage from "../hooks/useRedirectPage";

function Settings() {
  useRedirectPage(SETTING_PAGE);
  const settings = useSelector((s) => s.app_settings);
  const [postSettings, setPostSettings] = useState({});
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(SETTING);
  useDocumentTitle("システム設定 - 点検王");

  //Function help to set page settings
  const setTopPageSettings = async (e) => {
    const pageSettings = await getSettingPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(setPageLoading());
    setTopPageSettings()
      .then()
      .catch((e) => {
        errorStatusHandle(e.response);
        dispatch(clearPageLoading());
      });
    dispatch(fetchAppSettings());
    dispatch(resetAlert());
    setPostSettings({
      machine_input_method_text: settings.machine_input_methods.text,
      machine_input_method_select: settings.machine_input_methods.select,
      inspection_machine_change_method_text:
        settings.inspection.machine_change_method_text,
      inspection_machine_change_method_select:
        settings.inspection.machine_change_method_select,
      modify_time: settings.inspection.modify_time,
      // boundary_type_default: settings.inspection.boundary_type_default,
      app_name: settings.general.app_name,
      refresh_token_lifetime: settings.general.refresh_token_lifetime,
      inspection_start_datetime:
        settings.inspection_display.inspection_result_field
          .inspection_start_datetime,
      inspection_start_user_id:
        settings.inspection_display.inspection_result_field
          .inspection_start_user_id,
      operation_start_datetime:
        settings.inspection_display.inspection_result_field
          .operation_start_datetime,
      operation_start_user_id:
        settings.inspection_display.inspection_result_field
          .operation_start_user_id,
      registration_datetime:
        settings.inspection_display.inspection_result_field
          .registration_datetime,
      passed_symbol:
        settings.inspection_display.inspection_result_symbol.passed.symbol,
      passed_color:
        settings.inspection_display.inspection_result_symbol.passed.color,
      passed_background:
        settings.inspection_display.inspection_result_symbol.passed.background,
      failed_symbol:
        settings.inspection_display.inspection_result_symbol.failed.symbol,
      failed_color:
        settings.inspection_display.inspection_result_symbol.failed.color,
      failed_background:
        settings.inspection_display.inspection_result_symbol.failed.background,
      treatment_completed_symbol:
        settings.inspection_display.inspection_result_symbol.treatment_completed
          .symbol,
      treatment_completed_color:
        settings.inspection_display.inspection_result_symbol.treatment_completed
          .color,
      treatment_completed_background:
        settings.inspection_display.inspection_result_symbol.treatment_completed
          .background,
      not_inspected_symbol:
        settings.inspection_display.inspection_result_symbol.not_inspected
          .symbol,
      not_inspected_color:
        settings.inspection_display.inspection_result_symbol.not_inspected
          .color,
      not_inspected_background:
        settings.inspection_display.inspection_result_symbol.not_inspected
          .background,
      other_okng_symbol:
        settings.inspection_display.inspection_result_symbol.other_okng.symbol,
      other_okng_color:
        settings.inspection_display.inspection_result_symbol.other_okng.color,
      other_okng_background:
        settings.inspection_display.inspection_result_symbol.other_okng
          .background,
      bulk_approval_ng_items: settings.judgement.bulk_approval_ng_items,
      group_1_active: settings.machine_group.group_1.active,
      group_1_name: settings.machine_group.group_1.name,
      group_1_is_unique: settings.machine_group.group_1.is_unique,
      group_1_in_group_unique: settings.machine_group.group_1.in_group_unique,
      group_2_active: settings.machine_group.group_2.active,
      group_2_name: settings.machine_group.group_2.name,
      group_2_is_unique: settings.machine_group.group_2.is_unique,
      group_2_in_group_unique: settings.machine_group.group_2.in_group_unique,
      group_3_active: settings.machine_group.group_3.active,
      group_3_name: settings.machine_group.group_3.name,
      group_3_is_unique: settings.machine_group.group_3.is_unique,
      group_3_in_group_unique: settings.machine_group.group_3.in_group_unique,
      group_4_active: settings.machine_group.group_4.active,
      group_4_name: settings.machine_group.group_4.name,
      group_4_is_unique: settings.machine_group.group_4.is_unique,
      group_4_in_group_unique: settings.machine_group.group_4.in_group_unique,
      group_5_active: settings.machine_group.group_5.active,
      group_5_name: settings.machine_group.group_5.name,
      group_5_is_unique: settings.machine_group.group_5.is_unique,
      group_5_in_group_unique: settings.machine_group.group_5.in_group_unique,
      machine_active: settings.machine_group.machine.active,
      machine_name: settings.machine_group.machine.name,
      machine_is_unique: settings.machine_group.machine.is_unique,
      machine_in_group_unique: settings.machine_group.machine.in_group_unique,
      unapproved_notification_interval_time:
        settings.judgement.unapproved_notification_interval_time,
      approval_time_value: settings.judgement.approval_time_value,
      approval_time_unit: settings.judgement.approval_time_unit || "days",
      daily_approval_status: settings.inspection_status?.daily_approval_status,
      monthly_approval_status:
        settings.inspection_status?.monthly_approval_status,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSettings = (settingName, newValue) => {
    setPostSettings((preSettings) => {
      const newSettings = {
        ...preSettings,
        [settingName]: newValue,
      };
      return newSettings;
    });
  };

  const handleSubmit = async () => {
    try {
      dispatch(setButtonProcessing("btn-setting-update"));
      await updateSettings(postSettings)
        .then((res) => {
          // dispatch(setAlertError())
          setErrors({});
          dispatch(setAlertSuccess(res.message));
          dispatch(fetchAppSettings());
          dispatch(clearButtonProcessing("btn-setting-update"));
        })
        .catch((e) => {
          errorStatusHandle(e);
          if (e.status === 400) {
            dispatch(setUpdateMachineBatchAlertError(e.data));
            setErrors(e.data.errors);
            dispatch(clearButtonProcessing("btn-setting-update"));
          }
        });
      smoothScrollToTop();
    } catch (e) {}
  };

  return (
    <BackendLayout sidebar={true} breadcrumb={breadcrumb}>
      <PageTitle title="システム設定" />
      <ButtonDPad />
      <div className="w-fit 2xl:pr-0 pr-6">
        <RedirectAlert />
        <PageAlert />
        <Tabs
          style="underline"
          theme={tenkenTheme.setting_tabs}
          className="whitespace-nowrap"
        >
          <Tabs.Item title="設備入力画面">
            <EquipmentInput
              onSubmit={handleSubmit}
              settings={postSettings}
              onSettingChange={handleChangeSettings}
              errors={errors}
            />
          </Tabs.Item>
          <Tabs.Item active title="点検結果登録画面">
            <InspectionResultRegistration
              onSubmit={handleSubmit}
              settings={postSettings}
              onSettingChange={handleChangeSettings}
              errors={errors}
            />
          </Tabs.Item>
          <Tabs.Item title="承認状況画面">
            <ApprovalStatus
              onSubmit={handleSubmit}
              settings={postSettings}
              onSettingChange={handleChangeSettings}
              errors={errors}
            />
          </Tabs.Item>
          <Tabs.Item title="点検状況画面">
            <InspectionStatus
              onSubmit={handleSubmit}
              settings={postSettings}
              onSettingChange={handleChangeSettings}
              errors={errors}
            />
          </Tabs.Item>
          <Tabs.Item title="全画面共通">
            <CommonToAll
              onSubmit={handleSubmit}
              settings={postSettings}
              onSettingChange={handleChangeSettings}
              errors={errors}
            />
          </Tabs.Item>
        </Tabs>
      </div>
    </BackendLayout>
  );
}

export default Settings;
